var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6538 6.76931L24.1923 3.69238L25.7307 6.76931L28.8076 8.30777L25.7307 9.84623L24.1923 12.9232L22.6538 9.84623L19.5769 8.30777L22.6538 6.76931ZM10.3461 12.9232L13.423 6.76931L16.5 12.9232L22.6538 16.0001L16.5 19.077L13.423 25.2308L10.3461 19.077L4.19226 16.0001L10.3461 12.9232ZM24.1923 19.077L25.7307 22.1539L28.8076 23.6924L25.7307 25.2308L24.1923 28.3078L22.6538 25.2308L19.5769 23.6924L22.6538 22.1539L24.1923 19.077Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.0ac3d5ef8aa02cb20f04a7ac27e945b0.svg";
export { ForwardRef as ReactComponent };